import { render, staticRenderFns } from "./VtrReport.vue?vue&type=template&id=41315ca8&"
import script from "./VtrReport.vue?vue&type=script&lang=js&"
export * from "./VtrReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports